export default "__VITE_ASSET__830ea18f__"